import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { WidgetService } from 'src/app/services/widget.service';

@Component({
    selector: 'app-deploys-widget',
    templateUrl: './deploys-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './deploys-widget.component.scss'],
    standalone: false
})
export class DeploysWidgetComponent extends BaseWidgetComponent implements OnInit {
  @Output() onOpenDetail = new EventEmitter<{ parentId: string; serviceName: string }>();

  constructor(private _widgetService: WidgetService) {
    super();
  }

  ngOnInit(): void {
    this._subs.add = this._widgetService.resize$.subscribe((response) => {
      if ((<any>window).deploys) {
        (<any>window).deploys.onResize();
      }
    });
  }

  serviceClick($event: { parentId: string; serviceName: string }) {
    if (this.id !== $event.parentId) return;
    this.onOpenDetail.emit({ parentId: this.id, serviceName: $event.serviceName });
  }
}
